import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './components/mondiya/locales/english.json';
import cn from './components/mondiya/locales/chinese.json';
import tw from './components/mondiya/locales/taiwanese.json';
import sg from './components/mondiya/locales/singaporean.json';
import de from './components/mondiya/locales/german.json';
import ja from './components/mondiya/locales/japanese.json';
import sa from './components/mondiya/locales/arabic.json';
import kr from './components/mondiya/locales/korean.json';

// import bn from './components/mondiya/locales/bangla.json';
// import es from './components/mondiya/locales/spanish.json';
// import my from './components/mondiya/locales/malaysian.json';
// import fr from './components/mondiya/locales/french.json';

const savedLng = (() => {
    try { return localStorage.getItem('appLanguage') || 'en'; } catch (e) { return 'en'; }
})();

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en,
            },
            cn: {
                translation: cn,
            },
            tw: {
                translation: tw,
            },
            sg: {
                translation: sg,
            },
            de: {
                translation: de,
            },
            ja: {
                translation: ja,
            },
            sa: {
                translation: sa,
            },
            kr: {
                translation: kr,
            },
            // bn: {
            //     translation: bn,
            // },
            // es: {
            //     translation: es,
            // },
            // my: {
            //     translation: my,
            // },
            // fr: {
            //     translation: fr,
            // },
        },
        lng: savedLng,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;